import { AboutCard } from "./AboutCard";
import { cdnImages } from "../../utils/imageMap.cdn";

const aboutCardsData = [
  {
    img: cdnImages.aboutUs.img1,
    imgText: cdnImages.aboutUs.img1Text,
    description:
      "We design emotions. From museums to immersive festivals, we transform ideas into living experiences —where every detail is intentional, every space tells a story, and every visitor takes home a memory.",
    fontIndex: [2, 12, 13],
  },
  {
    img: cdnImages.aboutUs.img2,
    imgText: cdnImages.aboutUs.img2Text,
    description:
      "We are a full-cycle spatial design agency that imagines, designs, and transforms exhibits and environments to create maximum impact—blending immersive storytelling with art and technology.",
    fontIndex: [4, 5, 19, 20],
  },
  {
    img: cdnImages.aboutUs.img3,
    imgText: cdnImages.aboutUs.img3Text,
    description:
      "We shape feelings. By merging design, interaction, and atmosphere, we create environments that spark curiosity, foster connection, and turn fleeting moments into lasting memories.",
    fontIndex: [8, 22, 23],
  },
];

export const AboutCards = () => {
  return (
    <div className=" flex flex-col justify-center items-center lg:gap-32 ">
      {aboutCardsData.map((card, idx) => (
        <AboutCard
          key={idx}
          img={card.img}
          imgText={card.imgText}
          description={card.description}
          fontIndex={card.fontIndex}
          isOdd = {idx % 2 === 1}
        />
      ))}
    </div>
  );
};
